export enum RoutePaths {
  HOME = '/',
  ANTRAEGE = '/antraege/',
  SCHREIBTISCH = '/schreibtisch/',
  SCHREIBTISCH_CASE = '/schreibtisch/:caseId/',
  EINSTELLUNGEN = '/einstellungen/',
  CONFIGASSISTANT = '/config/'
}

export function getCasePath(caseId: string) {
  return `/schreibtisch/${caseId}`;
}
